
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../Contexts/AuthContext/AuthProvider";

const AgentPrivateRoute = ({ children }) => {
    const { authUser } = useContext(AuthContext);
    const location = useLocation();

    if (!authUser) {
        return (
            <Navigate
                to="/"
                state={{ from: location }}
                replace
            />
        );
    }

    if (authUser?.role === "admin") {
        return (
            <Navigate
                to="/admin/dashboard"
                state={{ from: location }}
                replace
            />
        );
    }

    if (authUser?.role !== "agent") {
        return (
            <Navigate
                to="/unauthorized"
                state={{ from: location }}
                replace
            />
        );
    }

    return children;
};

export default AgentPrivateRoute;
